export type DaysLeftTone = 'ok' | 'warning' | 'critical';

export const daysLeftTone = (days: number): DaysLeftTone => {
  if (days < 5) return 'critical';
  if (days < 15) return 'warning';
  return 'ok';
};
